import {Injectable} from "@angular/core";
import {AuthService} from "@webmate-web-core/shared/services/auth.service";
import { HttpClient } from "@angular/common/http";
import {FactSessionId, ProjectId} from "@webmate-web-core/shared/types/ids";
import {Observable} from "rxjs";
import {FactGenerationMode, FactSessionInfo, ScopedFactRequest} from "@webmate-web-core/shared/types/fact";
import {ArtifactAssociation} from "@webmate-web-core/shared/types/artifact";

@Injectable({
    providedIn: 'root'
})
export class FactApi {
    constructor (public oAuth2Service: AuthService, private http: HttpClient) {}

    generateFacts(projectId: ProjectId, goals: ScopedFactRequest[], associations: ArtifactAssociation[], factGenerationMode: FactGenerationMode): Observable<FactSessionId> {
        const generateFactsData: any = {
            goals,
            associations,
            mode: factGenerationMode
        };
        return this.http.post<FactSessionId>(`/projects/${projectId}/facts`, generateFactsData);
    }

    getFactSession(factSessionId: FactSessionId): Observable<FactSessionInfo> {
        return this.http.get<FactSessionInfo>(`/fact/factsessions/${factSessionId}`);
    }
}
